import React, { useRef } from "react";
import "./Solutions.css";
import { motion, useScroll, useTransform } from "framer-motion";
import { FaSearch, FaLightbulb, FaCode, FaRocket } from "react-icons/fa";

const steps = [
  {
    title: "Discovery",
    desc: "Understanding your business & goals",
    icon: <FaSearch />,
  },
  {
    title: "Strategy",
    desc: "Planning the best solution approach",
    icon: <FaLightbulb />,
  },
  {
    title: "Development",
    desc: "Designing & building your product",
    icon: <FaCode />,
  },
  {
    title: "Launch & Scale",
    desc: "Deploying and growing your system",
    icon: <FaRocket />,
  },
];

const ProcessSection = () => {
  const ref = useRef(null);


  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start center", "end center"],
  });

 
  const lineWidth = useTransform(scrollYProgress, [0, 0.9], ["0%", "100%"]);

  return (
    <section className="backdiv" ref={ref}>
      <h2 className="main-title">How We Work</h2>

      <div className="timeline">


        <div className="timeline-base" />


        <motion.div
          className="timeline-progress"
          style={{ width: lineWidth }}
        />

        {/* STEPS */}
        {steps.map((step, index) => (
          <motion.div
            className="step"
            key={index}
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
          >
            <div className="circle">
              {step.icon}
            </div>

            <div className="process_card">
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
            </div>
          </motion.div>
        ))}

      </div>
    </section>
  );
};

export default ProcessSection;